export default __webpack_public_path__ + "static/media/Society.884c31bc.svg";